<app-shell-v2 [hide]="!(showShell$ | async)" [customShell]="customShell$ | async">
    @if (!(isChangingProject$ | async)) {
        <router-outlet />
    }
</app-shell-v2>
